import { render, staticRenderFns } from "./HtmlTemplateForm.vue?vue&type=template&id=61838d70&"
import script from "./HtmlTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./HtmlTemplateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports